var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pageActions } from './types';
export var defaultPageData = {
    id: '',
    version: undefined,
    parent: null,
    title: '',
    boxAreas: { before: [], after: [], right: [], left: [] },
    blocks: { main: [], top: [], right: [], bottom: [], left: [] },
    photoURL: '',
    content: '',
    deleted: false,
    backgroundImage: false,
    bigHero: false
};
export var defaultPagesState = {
    isFetching: false,
    error: undefined,
    data: defaultPageData
};
export var pageReducer = function (state, action) {
    switch (action.type) {
        case pageActions.FETCH:
            return __assign(__assign({}, state), { data: defaultPageData, isFetching: true });
        case pageActions.SUCCESS:
            return __assign(__assign({}, state), { data: __assign({}, action.data), isFetching: false });
        case pageActions.FAILURE:
            return __assign(__assign({}, state), { error: action.error, isFetching: false });
        case pageActions.UPDATE:
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), action.data) });
        case pageActions.DEFAULT:
            return __assign(__assign({}, state), defaultPagesState);
        default:
            throw new Error("Unhandled action: " + action);
    }
};
